var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['basic-btn', {'current': _vm.buttonIndex === _vm.currentIndex}],attrs:{"data-index":_vm.buttonIndex}},[_vm._v(" "+_vm._s(_vm.buttonText)+" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }